export const name = "Breakup Edition"
export const menu = "Breakup"
export const edition = "Breakup Edition"
export const suggestedPlayer = "1+ player"
export const color = {
    primary: {
        main:  '#c10016',
        contrastText: '#ffffff',
    },
    secondary: {
        main:  '#c10016',
    }
}
export const levels = ['Breakup', 'Final Card']
export const isExpansion = false

export const backDesc = [
    "The end of a relationship\n is the beginning of a new\n one... with yourself"
]

export const instruction = [
    "Breakups are important. They teach us about ourselves. They show us what we want and what we don't. They allow us to move away from what isn't for us – and closer to what is. They even show us parts of ourselves we need to break up.", 
    "We've created this edition as a tool to self-reflect after a breakup. Journal your answers or play with a friend who can be a soundboard for your healing process. The end of a relationship is the beginning of a new one… with yourself.",
    "Ready?",
]

export const level1 = [ // 47 / 50 cards
    "What has helped you\n heal from a heartbreak\n in the past, besides time and\n meeting someone new?",
    "After your most recent\n breakup, what song did you\n play on repeat?",
    "Picture you're talking to\n your ex. Finish the sentence:\n You hurt me, but thank\n you for _________.",
    "What have all your\n previous relationships\n had in common that you'd like\n to avoid moving forward,\n if anything.",
    "Did their love leave you\n feeling good most of the time?\n If not, what was the dominant\n feeling they left you with?",
    "Were you lying\n to yourself about\n anything during your\n last relationship?\n If so, what was it?",
    "What did your last\n relationship make you\n appreciate about\n yourself?",
    "What are 3 things you can\n appreciate about being single\n (even if it feels hard)?",
    "Are you talking to\n other people currently? If\n so, are you seeking a real\n connection or needing\n a distraction?",
    "What part of your last\n relationship worked? What\n part of it hurt?",
    "Do you want closure\n or just an excuse to talk\n to them? Explain.",
    "How can you show up\n for yourself when no\n one else can?",
    "How has your last\n relationship prepared\n you for your next one?",
    "What parts of yourself do\n you need to break up with?",
    "What would feel best\n to fully accept in this\n current moment?",
    "Who in your life has\n been treating you right\n lately? Let them know before\n moving on to the next card.\n (Exes not included.)",
    "How did you get\n over your first\n love?",
    "Were you more attracted\n to their potential or who they\n really were? Explain.",
    "What title would you\n give this chapter of your\n healing process?",
    "Would you encourage\n your future child to be in a\n relationship like your last?\n Why or why not?",
    "What story about love\n have you been telling yourself\n that no longer serves you? How\n would you like to change\n that story?",
    "What can you be doing\n now with all the energy you\n were putting into them?",
    "What's the best lesson\n an ex has ever taught you?",
    "What were you\n over-rationalizing\n throughout your\n last relationship,\n if anything?",
    "Do you have a limiting\n belief about love? Where\n do you think it stems from?\n How can you challenge this belief?",
    "What can you do for\n yourself today, even if\n you don't enjoy it, to make\n future you happy?",
    "Did your last\n relationship reveal some\n toxic traits in yourself that\n you'd like to work on? If so,\n what are they?",
    "What is your heart\n telling you? What is your\n mind telling you?",
    "What do you want\n to receive from a future\n relationship? What do\n you want to give?\n Get specific.",
    "Were there any patterns\n in your previous relationship\n that you're newly aware of?\n If so, what were they?",
    "Significant other aside,\n when you visualize coming\n home to a life you love, what\n does that look like?\n Get specific.",
    "What was the biggest\n turning point in your\n dating life?",
    "What validation are you\n seeking from a partner? How\n can you give it to yourself?",
    "Imagine you're talking to\n your ex. Finish the sentence:\n I'm sorry for _________.",
    "What's your ex's name\n and one thing about them?",
    "Did you like your ex as a\n person? Or were you just in\n love? Explain.",
    "What feels unique about this heartbreak, if anything?",
    "What advice would you\n give a friend or loved one\n going through a similar\n situation as you?",
    "If you could ask your ex one thing and get a completely honest answer, what would it be?",

    "Wild Card Write down 3 things\n you love about yourself that aren't physical.",
    "Wild Card Write a note to your future\n self. Fold and place somewhere\n safe. Set a reminder to open\n 3 months from today.",
    "Wild Card Write a stand up routine about\n your last relationship. 1 minute.\n Read out loud.",
    "Wild Card Write down 3 things you love\n about yourself physically.\n Permission to brag.",
    "Wild Card Set a time this week to\n do something you love and\n limit any distractions.",
    "Wild Card Write down 3 things you\n wouldn't change about this\n current moment.",
    "Wild Card Draw how your\n heart feels today.",
    "Wild Card Write down 3 things\n about your last relationship\n that you will no longer accept\n moving forward. Get specific.",
    "Reminder Breakups skew\n your memory. Your\n ex was not perfect.\n You will feel better.",
    "Reminder Don't let your\n loneliness take you\n back to people who\n repeatedly hurt you.",
    "Reminder Your love life\n is one area of your\n life. Don't forget to\n nurture the rest.",
]

export const finalCard = [
    "Write a final note to your\n ex that they'll never see. Get\n it all off your chest. Tear\n when you feel ready."
]